import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Renderable } from '@components/Renderable';
import { Assembling } from '@components/Assembling';
import { Welding } from '@components/Welding';
import { Effects } from '@/effects/Effects';

/** Plays out the shipyard's ongoing work: hulls materialising and repair crews welding. */
export class HangarAnimationSystem extends System {
  update(_deltaTime: number): void {
    for (const ship of this.getEntitiesWithComponents(Assembling, Position, Renderable)) {
      const assembling = ship.getComponent(Assembling)!;
      const position = ship.getComponent(Position)!;
      const renderable = ship.getComponent(Renderable)!;

      assembling.frame++;
      const progress = Math.min(1, assembling.frame / assembling.duration);
      // Flickers into existence, steadying as it completes
      renderable.alpha = progress >= 1 ? 1 : progress * (0.75 + 0.25 * Math.sin(assembling.frame * 0.9));

      if (assembling.frame % 2 === 0) Effects.assemblySparks(this.world, position.x, position.y, renderable.color);

      if (progress >= 1) {
        ship.removeComponent(Assembling);
        Effects.warpIn(this.world, position.x, position.y, renderable.color);
      }
    }

    for (const ship of this.getEntitiesWithComponents(Welding, Position, Renderable)) {
      const welding = ship.getComponent(Welding)!;
      const position = ship.getComponent(Position)!;
      const size = ship.getComponent(Renderable)!.size;

      welding.frame++;
      if (welding.frame % 3 === 1) {
        const x = position.x + (Math.random() - 0.5) * size * 1.6;
        const y = position.y + (Math.random() - 0.5) * size * 1.0;
        Effects.weld(this.world, x, y);
      }

      if (welding.frame >= welding.duration) {
        ship.removeComponent(Welding);
        Effects.smoke(this.world, position.x, position.y, 2, '#6a6a78');
      }
    }
  }
}
